import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyDlaHPHPDNIe3SSPgLgyy2H2tum3V1WrgY",
  authDomain: "app.torchvolleyball.com",
  projectId: "torch-beach-app",
  storageBucket: "torch-beach-app.firebasestorage.app",
  messagingSenderId: "898374875054",
  appId: "1:898374875054:web:bee6ffc698148f5c813a3f",
  measurementId: "G-KY370F9NHY"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export default app;
